import React from "react";
import { Trash2 } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { shortDate } from "@/lib/format";
import { inputClass } from "@/components/Brand";

/** Searchable list of every account on the platform. */
export const AccountsPanel = ({ accounts, query, onQuery, onDelete }) => {
  const { t } = useI18n();

  return (
    <div className="border border-[#2A2A2A] bg-[#0F0F0F] p-5 sm:p-7 overflow-hidden" data-testid="accounts-list">
      <p className="eyebrow mb-4">{t("accounts")}</p>
      <p className="text-[11px] text-[#707070] mb-5">{t("accounts_hint")}</p>
      <input data-testid="account-search-input" value={query} onChange={(e) => onQuery(e.target.value)}
        placeholder={t("search_accounts")} className={`${inputClass} mb-5`} />
      <div className="max-h-[26rem] overflow-y-auto">
        {accounts.map((a) => (
          <div key={a.user_id} data-testid={`account-row-${a.user_id}`}
            className="flex flex-wrap items-center justify-between gap-3 py-3 border-b border-[#1E1E1E]">
            <div className="min-w-0">
              <p className="text-sm truncate">{a.email}</p>
              <p className="text-[11px] text-[#707070]">
                {a.name || "—"} · {a.studio_name || "—"} · {shortDate(a.created_at)}
              </p>
            </div>
            <span className="flex items-center gap-4">
              <span className="font-mono-accent text-[10px] tracking-[0.18em] uppercase text-[#A8A8A8]">
                {a.platform_role || a.tenant_role || "—"}
              </span>
              <button data-testid={`delete-account-${a.user_id}`} aria-label={t("delete_account")}
                onClick={() => onDelete(a)}
                className="text-[#5A5A5A] hover:text-[#8B0000]"><Trash2 size={14} /></button>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
